import { isEqual } from 'lodash';
import { createSelector } from 'redux-starter-kit';

const investmentAnalyserSelector = (state: any) => state.investmentAnalyser;
const checkedResearchInvestments = createSelector(
  investmentAnalyserSelector,
  subState =>
    subState.researchInvestments.filter(
      (investment: any) => investment.is_checked && !investment.loading
    )
);

const isCacheValid = (checkedInvestments: any, cachedInvestments: any) => {
  return (
    checkedInvestments.length === cachedInvestments.length &&
    checkedInvestments.every((investment: any) => {
      const match = cachedInvestments.find(
        (cachedInvestment: any) => cachedInvestment.id === investment.id
      );
      return !!match && isEqual(investment, match);
    })
  );
};

export const investmentAnalyserSelectors = {
  performancePeriod: createSelector(
    investmentAnalyserSelector,
    subState => subState.performancePeriod
  ),
  riskPerformancePeriod: createSelector(
    investmentAnalyserSelector,
    subState => subState.riskPerformancePeriod
  ),
  researchInvestments: createSelector(
    investmentAnalyserSelector,
    subState => subState.researchInvestments
  ),
  checkedResearchInvestments,
  pastPerformance: createSelector(
    investmentAnalyserSelector,
    subState => subState.pastPerformance
  ),
  pastPerformanceCacheIsValid: createSelector(
    investmentAnalyserSelector,
    checkedResearchInvestments,
    (subState, checkedResearchInvestments) =>
      isCacheValid(
        checkedResearchInvestments,
        subState.pastPerformance.investments
      )
  ),
  assetAllocation: createSelector(
    investmentAnalyserSelector,
    subState => subState.assetAllocation
  ),
  countryBreakdown: createSelector(
    investmentAnalyserSelector,
    subState => subState.countryBreakdown
  ),
  regionalBreakdown: createSelector(
    investmentAnalyserSelector,
    subState => subState.regionalBreakdown
  ),
  sectorBreakdown: createSelector(
    investmentAnalyserSelector,
    subState => subState.sectorBreakdown
  ),
  assetAllocationCacheIsValid: createSelector(
    investmentAnalyserSelector,
    checkedResearchInvestments,
    (subState, checkedResearchInvestments) =>
      isCacheValid(
        checkedResearchInvestments,
        subState.assetAllocation.investments
      )
  ),
  sectorBreakdownCacheIsValid: createSelector(
    investmentAnalyserSelector,
    checkedResearchInvestments,
    (subState, checkedResearchInvestments) =>
      isCacheValid(
        checkedResearchInvestments,
        subState.sectorBreakdown.investments
      )
  ),
  countryBreakdownCacheIsValid: createSelector(
    investmentAnalyserSelector,
    checkedResearchInvestments,
    (subState, checkedResearchInvestments) =>
      isCacheValid(
        checkedResearchInvestments,
        subState.countryBreakdown.investments
      )
  ),
  regionalBreakdownCacheIsValid: createSelector(
    investmentAnalyserSelector,
    checkedResearchInvestments,
    (subState, checkedResearchInvestments) =>
      isCacheValid(
        checkedResearchInvestments,
        subState.regionalBreakdown.investments
      )
  ),
  riskRatings: createSelector(
    investmentAnalyserSelector,
    subState => subState.riskRatings
  ),
  riskRatingsCacheIsValid: createSelector(
    investmentAnalyserSelector,
    checkedResearchInvestments,
    (subState, checkedResearchInvestments) =>
      isCacheValid(checkedResearchInvestments, subState.riskRatings.investments)
  ),
  scatterChartData: createSelector(
    investmentAnalyserSelector,
    subState => subState.scatterChartData
  ),
  cipOptions: createSelector(
    investmentAnalyserSelector,
    subState => subState.cipOptions
  )
};
